// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"2dbc694f","359":"2dbc694f","730":"47cad6e0","872":"7170a353","887":"1f5a47b3","925":"2dbc694f"}[chunkId] + ".chunk.css";
};